import React, { useState } from 'react';

const CourseContext = React.createContext();

const CourseProvider = (props) => {
  const [course, setCourse] = useState(props.value)

  return (
    <CourseContext.Provider value={[course, setCourse]}>
      {props.children}
    </CourseContext.Provider>
  );
};

export { CourseContext, CourseProvider}
